import { Component } from 'react';
import {
    Tabs, Tab, IconButton, Tooltip, Box, Typography, FormControlLabel, Checkbox, Button,
    Autocomplete,
    TextField
} from "@mui/material";
import './CommonTabs.css';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { clearCachevalue, getCachevalue, localGetItem, setCachevalue } from '../../Utility/Services/CacheProviderService';
import { AmountFormat, CheckAccessFunc } from '../CommonFunctions/CommonFunctions';
import CommonDatePicker from '../Common Components/CommonDatePicker';

export default class CommonTabs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            MainTabIndex: props.selectedTab ? props.selectedTab?.id : props.List[0]?.id,
            SubTabIndex: props.selectedTab ? (props.selectedTab?.subMenu.length > 0 ? props.selectedTab?.subMenu[0]?.id : 0) : 0,
            List: props.List ? props.List : [],
            SelectedItem: props.selectedTab ? props.selectedTab : props?.List[0],
            SelectedSubItem: props.selectedTab ? (props.selectedTab?.subMenu.length > 0 ? props.selectedTab?.subMenu[0] : null) : null,
            BackScreen: props.BackToHome ? props.BackToHome : null,
            isSubRendered: false,
            forcancel: false,
            isBillDoctor: JSON.parse(localGetItem("loggedInUserInfo"))?.bill_doctor_enabled ? true : false,
            ConsultantDataList: JSON.parse(localGetItem("DoctorsList")) ? JSON.parse(localGetItem("DoctorsList")) : [],
            consultantName: null,
            loginInfo:null
        }
    }
    componentDidMount() {
        var props = this.props
        let loginInfo = localGetItem('loggedInUserInfo')
        this.setState({
            List: props.List,
            SelectedItem: props.selectedTab ? props.selectedTab : props.List[0],
            MainTabIndex: props.selectedTab ? props.selectedTab?.id : props.List[0]?.id,
            BackScreen: props.BackToHome ? props.BackToHome : null,
            SubTabIndex: props.selectedTab ? (props.selectedTab?.subMenu.length !== 0 ? props.selectedTab?.subMenu[0]?.id : 0) : 0,
            SelectedSubItem: props.selectedTab ? (props.selectedTab?.subMenu.length > 0 ? props.selectedTab?.subMenu[0] : null) : null,
            forcancel: this.props.history?.location?.state?.isCancelBillFetched ? true : false,
            loginInfo:JSON.parse(loginInfo)
        },() => {
            if (this.state.SubTabIndex == 6.21 && !this.state.forcancel && this.state.isBillDoctor) {
                let patientData = getCachevalue("IppatientData")
                let doctorID = patientData ? JSON.parse(patientData)?.doctor_id : null
                let selectedDoc = this.state.ConsultantDataList?.find((item) => item?.doctor_id === doctorID)
                this.setState({ consultantName: selectedDoc ? selectedDoc : null })
            }
        })
    }
    componentDidUpdate(prevProps) {
        if (prevProps !== this.props && this.props) {
            if ((prevProps.selectedTab?.id != this.props.selectedTab?.id) || this.props?.history?.location?.state?.Reset) {
                this.setState({
                    forcancel: (this.props.history?.location?.state?.isCancelBillFetched) ? true : false,
                    List: this.props.List,
                    SelectedItem: this.props.selectedTab ? this.props.selectedTab : this.props.List[0],
                    MainTabIndex: this.props.selectedTab ? this.props.selectedTab?.id : this.props.List[0]?.id,
                    BackScreen: this.props.BackToHome ? this.props.BackToHome : null,
                    SubTabIndex: this.props.selectedTab ? (this.props.selectedTab?.subMenu.length !== 0 ? this.props.selectedTab?.subMenu[0]?.id : 0) : 0,
                    SelectedSubItem: this.props.selectedTab ? (this.props.selectedTab?.subMenu.length > 0 ? this.props.selectedTab?.subMenu[0] : null) : null,
                }, () => {
                    if (this.state.SubTabIndex == 6.21 && this.state.isBillDoctor) {
                        let patientData = getCachevalue("IppatientData")
                        let doctorID = patientData ? JSON.parse(patientData)?.doctor_id : null
                        let selectedDoc = this.state.ConsultantDataList?.find((item) => item?.doctor_id === doctorID)
                        this.setState({ consultantName: selectedDoc ? selectedDoc : null })
                    }
                })
            } else {
                this.setState({
                    forcancel: (this.props.history?.location?.state?.isCancelBillFetched) ? true : false,
                    List: this.props.List,
                    SelectedItem: this.props.selectedTab ? this.props.selectedTab : this.props.List[0],
                    MainTabIndex: this.props.selectedTab ? this.props.selectedTab?.id : this.props.List[0]?.id,
                    BackScreen: this.props.BackToHome ? this.props.BackToHome : null,
                    SubTabIndex: this.state.SubTabIndex ? this.state.SubTabIndex : (this.props.selectedTab?.subMenu.length !== 0 ? this.props.selectedTab?.subMenu[0]?.id : 0),
                    SelectedSubItem: this.state.SubTabIndex ? this.state.SelectedSubItem : (this.props.selectedTab?.subMenu.length > 0 ? this.props.selectedTab?.subMenu[0] : null),
                }, () => {
                    if (this.state.SubTabIndex == 6.21 && this.state.isBillDoctor) {
                        let patientData = getCachevalue("IppatientData")
                        let doctorID = this.props.billDocId ? this.props.billDocId : patientData ? JSON.parse(patientData)?.doctor_id : null
                        let selectedDoc = this.state.ConsultantDataList?.find((item) => item?.doctor_id === doctorID)
                        this.setState({ consultantName: selectedDoc ? selectedDoc : null })
                    }
                })
            }
        }
    }
    handleChange = (event, newValue) => {
        this.setState({
            MainTabIndex: newValue,
            SelectedItem: this.state.List.filter((item) => item?.id == newValue)[0]
        }, () => {
            if (getCachevalue('CurrentDoctorPatientData')) {
                setCachevalue(getCachevalue('CurrentDoctorPatientData'), "DoctorPatientData")
                clearCachevalue("CurrentDoctorPatientData");
            }
            if (getCachevalue('bill_doctor_id')) {
                clearCachevalue("bill_doctor_id")
            }
            let { history } = this.props
            history.push({ pathname: `${this.state.SelectedItem.path}` })
        })

    };
    handleChangesub = (event, newValue) => {
        if (getCachevalue('bill_doctor_id')) {
            clearCachevalue("bill_doctor_id")
        }
        this.setState({
            SubTabIndex: newValue,
            SelectedSubItem: this.state.SelectedItem.subMenu.filter((item) => item.id == newValue)[0]
        })
    };

    checkAccess = (data) => {
        try {
            let patientDatas = getCachevalue("patientData")
            let patients = JSON.parse(patientDatas)
            var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
            var UserData = myUser
            if (data.menuName === "Nurse Notes" && UserData?.module_name === "front_office") {
                if (patients?.appointment_id) { return true } else { return false }
            } else if (data.menuName === "Service Billing" || data.menuName === "Room Change" || data.menuName === "Receive Payment") {
                if (UserData?.module_name !== "nurse") { return true } else { return false }
            }
            // else if (data.menuName === "Billing") {
            //     if ((UserData?.module_name !== "nurse" && patients?.appointment_id) || (UserData?.module_name === "ot_management") || (UserData?.module_name === 'Doctor')) { return true } else { return false }
            // }
            else if (data.menuName === 'No Show Report') {
                if (localGetItem("noShowStatus") === "true") { return true } else { return false }
            }
            else {
                return true
            }
        }
        catch (e) {
            console.log(e?.message)
            return true
        }
    }

    SubTabcheckAccess = (data) => {
        try {
            var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
            var UserData = myUser
            if (data.menuName === "Doctor Notes" || data.menuName === "IV / IM Track" || data.menuName === "Pain Chart" || data.menuName === "Medication" || data.menuName === "Laboratory") {
                if (UserData?.module_name !== "nurse") { return true } else { return false }
            }
            else {
                return true
            }
        }
        catch (e) {
            return true
        }
    }

    FilterDate = (from, to, index) => {
        this.props.receiveDateChange(from, to, index)
    }

    renderMainComponent = (data, Type) => {
        if (data?.Access?.viewAccess === true) {
            return data?.component
        }
        else if (data?.Access?.viewAccess === false) {
            return <Typography className='eMed_NoAccess_Text' sx={{ paddingTop: Type === "Tab" ? "15.65vw" : "13vw" }}>No Access For This Screen</Typography>
        } else {
            return data?.component
        }
    }

    returnBackButtonName = () => {
        if (getCachevalue("OPCancelBilldata") || getCachevalue("IPCancelBilldata") || getCachevalue('RadCancelBillData')) {
            let CancelBillData = getCachevalue("OPCancelBilldata") ? JSON.parse(getCachevalue("OPCancelBilldata")) : JSON.parse(getCachevalue("IPCancelBilldata")) ? JSON.parse(getCachevalue("IPCancelBilldata")) : JSON.parse(getCachevalue("RadCancelBillData"))
            if (CancelBillData?.FromBills) {
                return "Back to bills"
            } else {
                return "Back to Overall bills"
            }
        } else if (getCachevalue("LabCancelBilldata")) {
            let CancelBillData = JSON.parse(getCachevalue("LabCancelBilldata"))
            if (CancelBillData?.FromBills) {
                return "Back to bills"
            } else if (CancelBillData?.FromStatus) {
                return "Back to Home"
            } else {
                return "Back to Overall bills"
            }
        }
    }

    CancellBackButton = () => {
        let { history } = this.props
        return (
            <Button
                startIcon={<ChevronLeftIcon />}
                size='small'
                variant='contained'
                sx={{ textTransform: 'capitalize', }}
                emed_tid="common_tabs_cancel_back_btn"
                onClick={() => {
                    if (getCachevalue("OPCancelBilldata")) {
                        let CancelBillData = JSON.parse(getCachevalue("OPCancelBilldata"))
                        if (CancelBillData?.FromBills) {
                            clearCachevalue("OPCancelBilldata");
                            clearCachevalue("isForCancelBill");
                            this.props.changeScreen()
                            this.setState({
                                MainTabIndex: 1.2,
                                SelectedItem: this.state.List.filter((item) => item.id == 1.2)[0],
                            }, () => {
                                setTimeout(() => {
                                    this.setState({
                                        SubTabIndex: 1.23,
                                        SelectedSubItem: this.state.SelectedItem.subMenu.filter((item) => item.id == 1.23)[0]
                                    })
                                }, 500)
                            })
                        } else {
                            clearCachevalue("OPCancelBilldata");
                            clearCachevalue("isForCancelBill");
                            history.push({ pathname: '/BillingTransaction/OverAllBills' })
                        }
                    } else if (getCachevalue("IPCancelBilldata")) {
                        let CancelBillData = JSON.parse(getCachevalue("IPCancelBilldata"))
                        if (this.props.billDocId) {
                            this.props.removeBillDoc()
                        }
                        if (CancelBillData?.FromBills) {
                            clearCachevalue("IPCancelBilldata");
                            clearCachevalue("isForCancelBill");
                            this.props.changeScreen()
                            this.setState({
                                MainTabIndex: 6.2,
                                SelectedItem: this.state.List.filter((item) => item.id == 6.2)[0],
                            }, () => {
                                setTimeout(() => {
                                    this.setState({
                                        SubTabIndex: 6.23,
                                        SelectedSubItem: this.state.SelectedItem.subMenu.filter((item) => item.id == 6.23)[0]
                                    })
                                }, 500)
                            })
                        } else {
                            clearCachevalue("IPCancelBilldata");
                            clearCachevalue("isForCancelBill");
                            history.push({ pathname: '/BillingTransaction/OverAllBills' })
                        }
                    } else if (getCachevalue("LabCancelBilldata")) {
                        let CancelBillData = JSON.parse(getCachevalue("LabCancelBilldata"))
                        if (CancelBillData?.FromBills) {
                            clearCachevalue("LabCancelBilldata");
                            clearCachevalue("isForCancelBill");
                            if (getCachevalue("patientData")) {
                                this.props.changeScreen()
                                history.push({ pathname: '/OPHome/PatientDetails/Billing' })
                                this.setState({
                                    MainTabIndex: 1.2,
                                    SelectedItem: this.state.List.filter((item) => item.id == 1.2)[0],
                                }, () => {
                                    setTimeout(() => {
                                        this.setState({
                                            SubTabIndex: 1.23,
                                            SelectedSubItem: this.state.SelectedItem.subMenu.filter((item) => item.id == 1.23)[0]
                                        })
                                    }, 500)
                                })
                            } else {
                                this.props.changeScreen()
                                history.push({ pathname: '/IPHome/PatientDetails/ServiceBilling' })
                                this.setState({
                                    MainTabIndex: 6.2,
                                    SelectedItem: this.state.List.filter((item) => item.id == 6.2)[0],
                                }, () => {
                                    setTimeout(() => {
                                        this.setState({
                                            SubTabIndex: 6.23,
                                            SelectedSubItem: this.state.SelectedItem.subMenu.filter((item) => item.id == 6.23)[0]
                                        })
                                    }, 500)
                                })
                            }
                        } else if (CancelBillData?.FromStatus) {
                            clearCachevalue("LabCancelBilldata");
                            clearCachevalue("isForCancelBill");
                            this.props.changeScreen()
                            history.push({ pathname: '/MainHome' })
                        } else {
                            clearCachevalue("LabCancelBilldata");
                            clearCachevalue("isForCancelBill");
                            history.push({ pathname: '/BillingTransaction/OverAllBills' })
                        }
                    } else if (getCachevalue("RadCancelBillData")) {
                        let CancelBillData = JSON.parse(getCachevalue("RadCancelBillData"))
                        if (JSON.parse(localGetItem("loggedInUserInfo"))?.module_name === "front_office") {
                            if (CancelBillData?.FromBills) {
                                clearCachevalue("LabCancelBilldata");
                                clearCachevalue("isForCancelBill");
                                clearCachevalue("RadCancelBillData");
                                if (getCachevalue("patientData")) {
                                    this.props.changeScreen()
                                    history.push({ pathname: '/OPHome/PatientDetails/Billing' })
                                    this.setState({
                                        MainTabIndex: 1.2,
                                        SelectedItem: this.state.List.filter((item) => item.id == 1.2)[0],
                                    }, () => {
                                        setTimeout(() => {
                                            this.setState({
                                                SubTabIndex: 1.23,
                                                SelectedSubItem: this.state.SelectedItem.subMenu.filter((item) => item.id == 1.23)[0]
                                            })
                                        }, 500)
                                    })
                                } else {
                                    this.props.changeScreen()
                                    history.push({ pathname: '/IPHome/PatientDetails/ServiceBilling' })
                                    this.setState({
                                        MainTabIndex: 6.2,
                                        SelectedItem: this.state.List.filter((item) => item.id == 6.2)[0],
                                    }, () => {
                                        setTimeout(() => {
                                            this.setState({
                                                SubTabIndex: 6.23,
                                                SelectedSubItem: this.state.SelectedItem.subMenu.filter((item) => item.id == 6.23)[0]
                                            })
                                        }, 500)
                                    })
                                }
                            } else {
                                clearCachevalue("RadCancelBillData");
                                clearCachevalue("isForCancelBill");
                                clearCachevalue('RadPatientData')
                                clearCachevalue('IsFromIPBill')
                                clearCachevalue('IsFromOPBill')
                                history.push({ pathname: '/BillingTransaction/OverAllBills' })
                            }
                        } else {
                            let CancelBillData = JSON.parse(getCachevalue("RadCancelBillData"))
                            if (CancelBillData?.FromBills) {
                                clearCachevalue("RadCancelBillData");
                                clearCachevalue("isForCancelBill");
                                history.push({ state: { billSummaryId: '', fromModifyBill: false, fromCancelBill: false } })
                                this.props.changeScreen()
                                this.setState({
                                    MainTabIndex: 45.2,
                                    SelectedItem: this.state.List.filter((item) => item.id == 45.2)[0],
                                }, () => {
                                    setTimeout(() => {
                                        this.setState({
                                            SubTabIndex: 45.23,
                                            SelectedSubItem: this.state.SelectedItem.subMenu.filter((item) => item.id == 45.23)[0]
                                        })
                                    }, 500)
                                })
                            } else {
                                clearCachevalue("RadCancelBillData");
                                clearCachevalue("isForCancelBill");
                                clearCachevalue('RadPatientData')
                                clearCachevalue('IsFromIPBill')
                                clearCachevalue('IsFromOPBill')
                                history.push({ pathname: '/RadiologyBillingTransaction/OverallBills', state: { fromModifyBill: false, billSummaryId: '', fromCancelBill: false } })
                            }
                        }

                    }
                }}
            >{this.returnBackButtonName()}</Button>
        )
    }

    render() {
        let { history } = this.props
        return (
            <div>
                <div className='eMed_tabWrapper'>
                    {
                        this.state.BackScreen === null ? null :
                            <div>
                                <Tooltip title="Back" placement='top' arrow>
                                    <IconButton
                                        disabled={(getCachevalue("isForCancelBill") === "true") || (getCachevalue("isForVisitreport") === "true") || (getCachevalue("IsForCheckedOut") === "true") || (getCachevalue("IsPORequestEdit") === "true") || (getCachevalue("isCanteenOverall") === "true") || (getCachevalue("DisableAllActions") === "true")}
                                        emed_tid="back_button"
                                        onClick={() => {
                                            history.push({ pathname: `${this.state.BackScreen}` })
                                            if (this.state.BackScreen !== "/IPHome/Demographics/AdmissionHistory") {
                                                clearCachevalue("patientData");
                                                clearCachevalue("IppatientData");
                                                clearCachevalue("OP_CreateAppointment_PatientId");
                                                clearCachevalue("OTpatientData");
                                                clearCachevalue("AppRequestPatientData");
                                                clearCachevalue("DoctorPatientData")
                                                clearCachevalue("CurrentDoctorPatientData")
                                                clearCachevalue('updatePatient')
                                                clearCachevalue('RadPatientData')
                                                clearCachevalue('QRRequestPatientData')
                                                clearCachevalue('IsFromIPBill')
                                                clearCachevalue('IsFromOPBill')
                                                clearCachevalue('reservePatientData')
                                                clearCachevalue('provisional_diagnosis')
                                                clearCachevalue('OP_CreateAppointment_PatientId')
                                                clearCachevalue('BillType')
                                                clearCachevalue('FromOtherScreen')
                                            }
                                            clearCachevalue("withoutAppointment");
                                            if(this.state.loginInfo?.module_name === 'front_office' && this.props.nurseState){
                                                this.props.changeNurse(false)
                                            }
                                        }}>
                                        <ChevronLeftIcon color={(getCachevalue("isForCancelBill") === "true") || (getCachevalue("isForVisitreport") === "true") || (getCachevalue("IsForCheckedOut") === "true") || (getCachevalue("IsPORequestEdit") === "true") || (getCachevalue("isCanteenOverall") === "true") ? "grey" : 'primary'} />
                                    </IconButton>
                                </Tooltip>
                            </div>
                    }
                    <div >
                        {/* <Box> */}
                        <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'} width={"90vw"}>
                            <Tabs
                                value={this.state.MainTabIndex}
                                onChange={this.handleChange}
                                variant="scrollable"
                                scrollButtons={'auto'}
                                sx={{ minHeight: '1vw' }}
                            >
                                {this.state.List && this.state.List.length > 0 && this.state.List.map((data, index) => {
                                    if (this.checkAccess(data)) {
                                        return (
                                            <Tab
                                                sx={{ textTransform: 'capitalize', minHeight: '1vw', fontWeight: 600 }}
                                                key={data.id}
                                                value={data.id}
                                                label={
                                                    ((data.menuName === 'Inbound' || data.menuName === 'Outbound') && data?.count != 0 && this.state.loginInfo?.module_name === 'Pharmacy') ? 
                                                    <Box sx={{display: 'flex', flexDirection: 'row', fontSize: '.85vw'}}>
                                                      {data.menuName} <span style={{backgroundColor: '#D32F2F', border: '1px solid #D32F2F', borderRadius: '12px',padding: '2px',
                                                          color: '#FFFFFF', display: 'inline-block', minWidth: '20px', textAlign: 'center', fontSize: '.7vw', marginLeft: '.2vw'
                                                      }}>
                                                          {data?.count}
                                                      </span>
                                                    </Box> : 
                                                    <Box sx={{display: 'flex', flexDirection: 'row', fontSize: '.85vw'}}>{data.menuName}</Box>
                                                  }
                                          
                                                emed_tid={data.testID || `common_tabs_main_tab_${data.id}`}
                                                disabled={getCachevalue("isForCancelBill") === "true" || (getCachevalue("isForVisitreport") === "true") || (getCachevalue("IsForCheckedOut") === "true") || (getCachevalue("IsPORequestEdit") === "true") || (getCachevalue("isCanteenOverall") === "true") || (getCachevalue("isInRadiologyBilling") === "true") || (getCachevalue("DisableAllActions") === "true")} />
                                        
                                            )
                                    }
                                }
                                )}
                            </Tabs>
                            {this.state?.List[0]?.menuName === "Quick Billing & Appointment" || this.state?.List[0]?.menuName === "Quick Billing" || this.state?.List[1]?.menuName === "Create Appointment" ?
                               <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                    <Box width={"50dvw"} display={Object.keys(this.props?.VisitDateBalAmount ? this.props?.VisitDateBalAmount : {})?.length > 0 ? 'flex' : "none"} justifyContent={"flex-end"} marginRight={"0.625dvw"}>
                                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: "0.5vw" }}>
                                            <Typography fontSize={"0.9vw"}>Previous Credit Balance : </Typography>
                                            <Typography fontSize={"0.9vw"} fontWeight={600} marginLeft={"0.3vw"}>{AmountFormat(this.props?.VisitDateBalAmount?.total_outstanding || 0)}</Typography>
                                        </Box>
                                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: "1.5vw" }}>
                                            <Typography fontSize={"0.9vw"}>Previous Advance Balance : </Typography>
                                            <Typography fontSize={"0.9vw"} fontWeight={600} marginLeft={"0.3vw"}>{AmountFormat(this.props?.VisitDateBalAmount?.advance_balance || 0)}</Typography>
                                        </Box>
                                    </Box>
                                    <FormControlLabel checked={this.props.nurseState} control={<Checkbox emed_tid="common_tabs_nurse_checkbox" />} onClick={(e) => {
                                        this.props.changeNurse(e.target.checked)
                                    }} label="Nurse" />
                                </Box> : null}
                            {(this.state.SelectedItem?.menuName === "In Patient List" || window.location.pathname === "/IPHome/Reservation") ?
                                <Box sx={{ position: "relative", top: "0.4vw", width: "13vw" }}>
                                    <CommonDatePicker
                                        FromDate={this.props.dateDetails?.fromDate}
                                        ToDate={this.props.dateDetails?.toDate}
                                        DateIndex={this.props.dateDetails?.dateIndex}
                                        SelectedDates={this.FilterDate.bind(this)}
                                        HideAllMenu={true}
                                        HideDate={true}
                                        Future={true}
                                        AllowAllDate={true} />
                                </Box> : null}
                            {(getCachevalue("isForCancelBill") === "true" && (getCachevalue("LabCancelBilldata") || ((getCachevalue("RadCancelBillData")) && JSON.parse(localGetItem("loggedInUserInfo"))?.module_name === "front_office"))) ? this.CancellBackButton() : null}
                            {getCachevalue("isForVisitreport") === "true" ?
                                <Button
                                    startIcon={<ChevronLeftIcon />}
                                    size='small'
                                    variant='contained'
                                    sx={{ textTransform: 'capitalize', }}
                                    onClick={() => {
                                        clearCachevalue("isForVisitreport");
                                        this.props.history.push({ pathname: "/DoctorHome/Reports/DoctorVisit" })
                                    }}
                                    emed_tid="common_tabs_back_to_visit_report_btn"
                                >Back to Visit Report</Button> : null}
                            {(getCachevalue("IsForCheckedOut") === "true") ? <Button
                                startIcon={<ChevronLeftIcon />}
                                size='small'
                                variant='contained'
                                sx={{ textTransform: 'capitalize', }}
                                onClick={() => {
                                    clearCachevalue("IsForCheckedOut");
                                    clearCachevalue('IppatientData')
                                    this.props.history.push({ pathname: "/IPHome" })
                                }}
                                emed_tid="common_tabs_back_to_checkout_btn"
                            >Back to Checkout</Button> : null}
                            {(getCachevalue("IsPORequestEdit") === "true") ? <Button
                                startIcon={<ChevronLeftIcon />}
                                size='small'
                                variant='contained'
                                sx={{ textTransform: 'capitalize', }}
                                onClick={() => {
                                    clearCachevalue("IsPORequestEdit");
                                    this.props.history.push({ pathname: "/PharmacyPurchase/PurchaseRequest" })
                                }}
                                emed_tid="common_tabs_back_to_po_request_btn"
                            >Back to PO Request</Button> : null}
                            {(getCachevalue("isCanteenOverall") === "true") ? <Button
                                startIcon={<ChevronLeftIcon />}
                                size='small'
                                variant='contained'
                                sx={{ textTransform: 'capitalize', }}
                                onClick={() => {
                                    clearCachevalue("isCanteenOverall")
                                    this.props.history.push({ pathname: "/CanteenBillingTransaction" })
                                }}
                                emed_tid="common_tabs_back_to_overall_bill_btn"
                            >Back to Overall Bill</Button> : null}
                        </Box>
                        {/* </Box> */}
                    </div>
                </div>

                <div>
                    {
                        Object.keys(this.state.SelectedItem || {}).length !== 0 ?
                            this.state.SelectedItem.subMenu?.length === 0 ?
                                <div className='eMed_MainComponentDiv'>
                                    {this.renderMainComponent(this.state.SelectedItem, "Tab")}
                                </div>
                                :
                                <div>
                                    {
                                        this.state.SubTabIndex != 0 ?
                                            <div>
                                                <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'}>
                                                    <Tabs
                                                        value={this.state.SubTabIndex}
                                                        onChange={this.handleChangesub}
                                                        variant="scrollable"
                                                        scrollButtons={"auto"}
                                                        sx={{ minHeight: '1vw' }}
                                                    >
                                                        {
                                                            this.state.SelectedItem.subMenu.map((data, index) => {
                                                                // if(this.SubTabcheckAccess(data)){
                                                                let ipPatientData = getCachevalue("IppatientData")
                                                                let patientData = JSON.parse(ipPatientData)
                                                                return (
                                                                    <Tab sx={{ textTransform: 'capitalize', minHeight: '1vw', fontWeight: 600 }} disabled={(getCachevalue('RadCancelBill') && data?.id !== 45.21) || (getCachevalue("isForCancelBill") === "true") ? true : false} key={data.id} value={data.id} label={data.menuName} emed_tid={data.testID || `common_tabs_sub_tab_${data.id}`} />
                                                                )
                                                                // }

                                                            })
                                                        }
                                                    </Tabs>
                                                    {(this.state.SubTabIndex == 1.21 || this.state.SubTabIndex == 6.21) ?
                                                        <Box sx={{ display: 'flex', alignItems: "center", gap: '1vw' }}>
                                                            {(this.state.isBillDoctor && this.state.SubTabIndex == 6.21) ?
                                                                <Autocomplete
                                                                    options={this.state.ConsultantDataList}
                                                                    disableClearable
                                                                    getOptionLabel={(options) => typeof (options) === 'string' ? options : (options.doctor_name ? options.doctor_name : null)}
                                                                    onChange={(e, value) => {
                                                                        this.setState({ consultantName: value })
                                                                        setCachevalue(value?.doctor_id, "bill_doctor_id")
                                                                    }}
                                                                    disabled={(this.state.forcancel && !JSON.parse(getCachevalue("IPCancelBilldata"))?.isForEditBill) ? true : false}
                                                                    value={this.state.consultantName || null}
                                                                    size="small"
                                                                    sx={{ width: "12vw", marginTop: '0.5vh', marginLeft: this.state.forcancel ? '47dvw' : 0 }}
                                                                    renderInput={(params) => <TextField {...params} label={'Billed Doctor'} InputProps={{ ...params.InputProps, sx: { height: '4vh' } }} emed_tid="common_tabs_billed_doctor_autocomplete" />}
                                                                    renderOption={(props, option) => (
                                                                        <li {...props} key={option?.id}>
                                                                            <Typography fontSize={'0.9vw'}>{option.doctor_name}</Typography>
                                                                        </li>
                                                                    )}
                                                                />
                                                                : null}
                                                            {!this.state.forcancel ?
                                                                <Box sx={{ display: 'flex', gap: '1vw' }}>
                                                                    <Button
                                                                        disabled={!CheckAccessFunc('front_office', 'Billing', 'Laboratory Billing', null, 'Tab')?.editAccess}
                                                                        sx={{ width: '10vw', textTransform: 'capitalize', height: '2vw' }} variant='contained' size='small' onClick={() => {
                                                                            if (this.state?.List[1]?.menuName === "Billing") {
                                                                                setCachevalue(true, 'isInRadiologyBilling')
                                                                                let patientDatas = getCachevalue("patientData")
                                                                                let patients = JSON.parse(patientDatas)
                                                                                this.props.history.push({ pathname: "/Billing", state: { patientData: patients } })
                                                                            } else if (this.state?.List[1]?.menuName === "Service Billing") {
                                                                                let patientDatas = getCachevalue("IppatientData")
                                                                                let IPpatients = JSON.parse(patientDatas)
                                                                                setCachevalue(true, 'isInRadiologyBilling')
                                                                                this.props.history.push({ pathname: "/Billing", state: { IP_patientData: IPpatients } })
                                                                            }
                                                                        }}
                                                                        emed_tid="common_tabs_laboratory_btn">{"laboratory"}</Button>
                                                                    {localGetItem("Show_Radiology_Bills_In_FO") === "true" ? <Button sx={{ width: '10dvw', textTransform: 'capitalize', height: '2dvw' }} variant='contained' size='small' onClick={() => {
                                                                        if (this.state?.List[1]?.menuName === "Billing") {
                                                                            let patientDatas = getCachevalue("patientData")
                                                                            let patients = JSON.parse(patientDatas)
                                                                            setCachevalue(true, 'isInRadiologyBilling')
                                                                            this.props.history.push({ pathname: "/Billing/RadiologyBilling", state: { BillFromOP: true, patientData: patients } })
                                                                        } else if (this.state?.List[1]?.menuName === "Service Billing") {
                                                                            let patientDatas = getCachevalue("IppatientData")
                                                                            let IPpatients = JSON.parse(patientDatas)
                                                                            setCachevalue(true, 'isInRadiologyBilling')
                                                                            this.props.history.push({ pathname: "/Billing/RadiologyBilling", state: { BillFromIP: true, patientData: IPpatients } })
                                                                        }
                                                                    }}
                                                                    emed_tid="common_tabs_radiology_btn">{"Radiology"}</Button> : null}
                                                                    {(localGetItem("enable_multibilling") === "true" && localGetItem("isNewBilling") === "false") ? <Button sx={{ width: '10dvw', textTransform: 'capitalize', height: '2dvw' }} variant='contained' size='small'
                                                                        onClick={() => {
                                                                            if (this.state?.List[1]?.menuName === "Billing") {
                                                                                let patientDatas = getCachevalue("patientData")
                                                                                let patients = JSON.parse(patientDatas)
                                                                                setCachevalue(true, 'isInRadiologyBilling')
                                                                                this.props.history.push({ pathname: "/Billing/MultiBilling", state: { service_number: patients?.op_number } })
                                                                            } else if (this.state?.List[1]?.menuName === "Service Billing") {
                                                                                let patientDatas = getCachevalue("IppatientData")
                                                                                let patients = JSON.parse(patientDatas)
                                                                                setCachevalue(true, 'isInRadiologyBilling')
                                                                                this.props.history.push({ pathname: "/Billing/MultiBilling", state: { service_number: patients?.ip_number } })
                                                                            }
                                                                        }}
                                                                        emed_tid="common_tabs_multi_billing_btn">{"Multi Billing"}</Button> : null}
                                                                </Box> : null}
                                                        </Box>
                                                        : null}
                                                    {(getCachevalue("isForCancelBill") === "true") ? this.CancellBackButton() : null}
                                                </Box>
                                                <div className='eMed_SubComponentDiv'>
                                                    {this.renderMainComponent(this.state.SelectedSubItem, "SubTab")}
                                                </div>
                                            </div> : null
                                    }
                                </div>
                            : null
                    }
                </div>
            </div>
        )
    }
}
